import {
	ContextMenu,
	ContextMenuContent,
	ContextMenuItem,
	ContextMenuTrigger,
} from "@acme/ui/context-menu";
import {
	type TreeInformation,
	type TreeItem,
	type TreeItemRenderContext,
	useTree,
} from "react-complex-tree";
import { FileIcon, FolderIcon } from "../FileIcon";

export interface FileNodeProps {
	item: TreeItem;
	depth: number;
	children: React.ReactNode | null;
	title: React.ReactNode;
	arrow: React.ReactNode;
	context: TreeItemRenderContext;
	info: TreeInformation;
}

export const FileNode: React.FC<FileNodeProps> = ({
	item,
	depth,
	title,
	context,
	arrow,
	children,
}) => {
	const InteractiveComponent = context.isRenaming
		? ("div" as const)
		: ("button" as const);

	const tree = useTree();

	return (
		<ContextMenu>
			<ContextMenuTrigger>
				<li
					{...context.itemContainerWithChildrenProps}
					style={{
						margin: 0,
						paddingLeft: `${depth * 20}px`,
						display: "flex",
						flexDirection: "column",
						alignItems: "flex-start",
					}}
				>
					<InteractiveComponent
						{...context.itemContainerWithoutChildrenProps}
						{...context.interactiveElementProps}
						type={context.isRenaming ? ("button" as const) : undefined}
					>
						{arrow}
						{title}
					</InteractiveComponent>
					{children}
				</li>
			</ContextMenuTrigger>
			<ContextMenuContent>
				<ContextMenuItem onClick={() => tree.setRenamingItem(item.index)}>
					Rename
				</ContextMenuItem>
				<ContextMenuItem>Duplicate</ContextMenuItem>
				<ContextMenuItem>Download</ContextMenuItem>
				<ContextMenuItem>Delete</ContextMenuItem>
			</ContextMenuContent>
		</ContextMenu>
	);
};

export const FileNodeTitle: React.FC<{
	title: string;
	item: TreeItem;
	context: TreeItemRenderContext;
	info: TreeInformation;
}> = ({ title, item, context, info }) => {
	return (
		<div className="flex flex-row items-center gap-2">
			{item.isFolder ? (
				<FolderIcon isOpen={context.isExpanded} />
			) : (
				<FileIcon filename={title} />
			)}
			{title}
		</div>
	);
};
